"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _getSizeToken = _interopRequireDefault(require("./getSizeToken"));

var _getPadding = _interopRequireDefault(require("./getPadding"));

var _consts = require("./consts");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getCommonProps = function getCommonProps(_ref) {
  var width = _ref.width,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? _consts.SIZE_OPTIONS.NORMAL : _ref$size,
      theme = _ref.theme,
      iconRight = _ref.iconRight,
      iconLeft = _ref.iconLeft,
      children = _ref.children;
  var onlyIcon = Boolean(iconLeft && !children);
  var hasCenteredContent = Boolean(iconLeft && !children || children && !(iconLeft || iconRight));
  return _objectSpread(_objectSpread({}, (0, _getSizeToken.default)(size, theme)), {}, {
    width: width,
    padding: (0, _getPadding.default)(onlyIcon, iconRight, iconLeft, size, theme),
    fontWeight: theme.orbit.fontWeightMedium,
    contentAlign: onlyIcon || hasCenteredContent ? "center" : "space-between",
    contentWidth: "100%"
  });
};

var _default = getCommonProps;
exports.default = _default;